import React, { ReactNode } from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { useThemeContext } from 'contexts/theme';
import { ThemeNames } from 'types/themes';

interface Props {
  label: string;
  children: ReactNode;
  testId?: string;
  isFullScreen?: boolean;
  gtmTrackEvent?: any;
  borderless?: boolean;
}

export default function Tab({ label, children, testId, isFullScreen, borderless }: Props) {
  const { themeName } = useThemeContext();
  const expTabStyles = themeName !== ThemeNames.ZOOCASA ? styles.exptabs : '';

  return (
    <div className={buildClassName(
      styles.component, expTabStyles, isFullScreen && styles['component-full-screen'], borderless && styles.borderless
    )} data-testid={testId}>
      {!isFullScreen && <h2 className={styles.title}>{label}</h2>}
      {children}
    </div>
  );
}
